var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOutlinedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5C24.4035 5 29.9998 10.5966 30 17.5C30 24.4036 24.4036 30 17.5 30C10.5966 29.9998 5 24.4035 5 17.5C5.00018 10.5967 10.5967 5.00018 17.5 5Z",
    stroke: "#17B26A",
    strokeWidth: 1.66667
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0.833008C26.7047 0.833008 34.167 8.29525 34.167 17.5C34.167 26.7047 26.7047 34.167 17.5 34.167C8.29525 34.167 0.833008 26.7047 0.833008 17.5C0.833008 8.29525 8.29525 0.833008 17.5 0.833008Z",
    stroke: "#17B26A",
    strokeWidth: 1.66667
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2146_3125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7503 17.5003L16.2503 20.0003L21.2503 15.0003M25.8337 17.5003C25.8337 22.1027 22.1027 25.8337 17.5003 25.8337C12.898 25.8337 9.16699 22.1027 9.16699 17.5003C9.16699 12.898 12.898 9.16699 17.5003 9.16699C22.1027 9.16699 25.8337 12.898 25.8337 17.5003Z",
    stroke: "#36B544",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2146_3125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutlinedCircle);
export default __webpack_public_path__ + "static/media/check-outlined-circle.d276758fe20d90ba3ad792766e6b2732.svg";
export { ForwardRef as ReactComponent };